// Shared password strength/match criteria — used by both the checkout
// account-signup form and the /account registration form, so the rules
// and the live checklist behavior stay identical in both places.

export const passwordCriteriaRules = [
  { attr: 'length',    test: (v, _) => v.length >= 8 },
  { attr: 'uppercase', test: (v, _) => /[A-Z]/.test(v) },
  { attr: 'lowercase', test: (v, _) => /[a-z]/.test(v) },
  { attr: 'number',    test: (v, _) => /[0-9]/.test(v) },
  { attr: 'special',   test: (v, _) => /[^A-Za-z0-9]/.test(v) },
  { attr: 'match',     test: (v, c) => v.length > 0 && v === c },
]

// Prepends a status icon to each [data-rule] list item, once.
export function injectCriteriaIcons(scope = document) {
  scope.querySelectorAll('[data-rule]').forEach((li) => {
    if (li.querySelector('.criteria-icon')) return
    const icon = document.createElement('span')
    icon.className = 'material-icons-outlined criteria-icon'
    icon.setAttribute('aria-hidden', 'true')
    icon.textContent = 'radio_button_unchecked'
    li.prepend(icon)
  })
}

// Evaluates all rules against the current field values and updates the
// checklist's icons/classes in place.
export function evaluatePasswordCriteria(passwordField, confirmField, scope = document) {
  const value = passwordField.value
  const confirm = confirmField ? confirmField.value : ''
  passwordCriteriaRules.forEach(({ attr, test }) => {
    const li = scope.querySelector(`[data-rule="${attr}"]`)
    if (!li) return
    const icon = li.querySelector('.criteria-icon')
    const met = test(value, confirm)
    li.classList.toggle('criteria-met', met)
    if (icon) icon.textContent = met ? 'check_circle' : 'radio_button_unchecked'
  })
}
